import React, { useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Loader2 } from 'lucide-react';

const LoadingScreen = ({ onComplete }) => {
  
  useEffect(() => {
    // Afficher pendant 2 secondes puis passer aux résultats
    const timer = setTimeout(() => {
      onComplete();
    }, 2000);
    
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="min-h-screen bg-[#0f1c47] flex items-center justify-center p-4">
      <div className="max-w-md mx-auto w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_manager-inventory/artifacts/kqdhn43c_2024_10_make_it_matter.png" 
            alt="WEDO" 
            className="mx-auto h-14 object-contain"
          />
        </div>

        <Card className="bg-white border-0 shadow-2xl">
          <CardContent className="p-8 text-center">
            {/* Loader animé */}
            <div className="mb-6">
              <div className="relative w-20 h-20 mx-auto">
                <Loader2 className="w-20 h-20 text-[#e62c86] animate-spin" />
              </div>
            </div>
            
            {/* Titre */}
            <h2 className="text-xl font-bold text-[#0f1c47] mb-3">
              Analyse de votre diagnostic…
            </h2>
            
            {/* Texte */}
            <p className="text-gray-600">
              Nous analysons les dynamiques de votre équipe.
            </p>
            
            {/* Barre de progression animée */}
            <div className="mt-6 w-full h-1 bg-gray-100 rounded-full overflow-hidden">
              <div 
                className="h-full rounded-full animate-pulse"
                style={{
                  background: 'linear-gradient(90deg, #e62c86, #f3a114, #52a385)',
                  animation: 'loading 2s ease-in-out'
                }}
              />
            </div>
          </CardContent>
        </Card>
      </div>
      
      {/* CSS Animation */}
      <style>{`
        @keyframes loading {
          0% { width: 0%; }
          100% { width: 100%; }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
